import { TableChangeSource } from '../TableTypes';

export const isTableCellMetaChangeSource = (source?: string): boolean =>
    source?.startsWith(`${TableChangeSource.CELL_META_PREFIX}.`) ?? false;

export const getTableChangeSourceWithTransactionId = (source: TableChangeSource, transactionId?: number): string =>
    `${source}:${transactionId}`;

export const getTransactionIdFromTableChangeSource = (source?: string): number | undefined => {
    const transactionIdStr = source?.split(':')?.[1];
    if (!transactionIdStr) return undefined;

    const transactionId = parseInt(transactionIdStr, 10);
    return Number.isNaN(transactionId) ? undefined : transactionId;
};
